import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert, Button } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { PLAINTIFF_SEARCH_QUERY } from '../../../graphql.js'
import PlaintiffSearchForm from './PlaintiffSearchForm'
import { getData } from '../CustomUtils.js'
import ColumnHeadings from '../ColumnHeadings.js'
import { configValue } from '../../../utils'

const PLAINTIFF_SEARCH = gql(PLAINTIFF_SEARCH_QUERY)

export default function PlaintiffSearch({ location, largeChoice, largeChoiceCallback, plaintiffSearchCallback }) {
  console.log('PlaintiffSearch rendered:', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  let maxDaysAfterClose = configValue('Plaintiff Selection Days Closed Limit') ? configValue('Plaintiff Selection Days Closed Limit') : 150

  useEffect(() => {
    if (results) {
      setResults(null)
    }
    getData(location, PLAINTIFF_SEARCH, 'plaintiffSearch', setResults, setGraphQLErrors)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  function selectClicked(e) {
    console.log('selectClicked',e.target)
    const selectedValue = {
      value: e.target.id,
      label: e.target.value
    }
    largeChoiceCallback(selectedValue)
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    if (largeChoice) {
      results.columnHeadings.push('')
    }

    const resultRows = []
    let row = []
    for (let i = 0; i < results.reportData.length; i++) {
      for (let j = 0; j < results.reportData[i].length; j++) {
        row.push(<td key={j}>{results.reportData[i][j]}</td>)
      }
      if (largeChoice) {
        const plaintiffName = `${results.reportData[i][1]}, ${results.reportData[i][2]}`
        const plaintiffStatus = results.reportData[i][4]
        const plaintiffId = results.reportData[i][8]
        let selectButton = <Button id={plaintiffId} value={plaintiffName} onClick={(e) => selectClicked(e)}>Select</Button>
        if ( plaintiffStatus === 'Closed') {
          const dateClosed = new Date(results.reportData[i][5])
          //console.log(dateClosed)
          const today = new Date()
          const daysClosed = (today.getTime() - dateClosed.getTime())/(1000*60*60*24)
          //console.log(daysClosed, maxDaysAfterClose)
          if (daysClosed > maxDaysAfterClose) {
            selectButton = `Closed for more than ${maxDaysAfterClose} days`
          }
        }
        row.push(<td key={-i-1}>{selectButton}</td>)
      }
      resultRows.push(<tr key={i}>{row}</tr>)
      row = []
    }
    return (
      <div className="custom-scroll">
        <PlaintiffSearchForm location={location} largeChoice={largeChoice} plaintiffSearchCallback={plaintiffSearchCallback}/>
        <Table bordered style={{width: 'auto', marginLeft: 'auto', marginRight: 'auto'}}>
          <thead>
            <ColumnHeadings results={results} noNumberRow={true} />
          </thead>
          <tbody>
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}
